function AboutUs() {
    return (
      <div style={{ padding: "40px", maxWidth: "900px", margin: "auto", fontFamily: "Arial" }}>
        <h1>About BigStyles</h1>
        <p style={{ fontSize: "18px", lineHeight: "1.6" }}>
          Welcome to BigStyles – your ultimate destination for trendy and affordable clothing for men, women, and kids. 
          We believe fashion should be fun, expressive, and accessible. 
          Whether you're shopping for a casual outfit, statement accessories, or everyday basics, we’ve got you covered.
        </p>
        <p style={{ fontSize: "18px", marginTop: "20px" }}>
          Our journey began with a simple idea: to make fashion joyful and inclusive. 
          We handpick our collections, ensuring they meet both quality and affordability. 
          With fast delivery, easy returns, and dedicated support – we bring the mall to your mobile!
        </p>
      </div>
    );
  }
  
  export default AboutUs;
  